// Formattazione condivisa tra il diario di un processo e l'elenco trasversale delle esecuzioni IA.

// Le date arrivano in UTC ma senza fuso: SQL le restituisce con Kind non specificato e il
// serializzatore non aggiunge la Z. Senza questo, `new Date()` le legge come ora locale e il
// diario risulta spostato di tutto il fuso — di notte, del giorno sbagliato.
export function asDate(s) {
  if (!s) return null
  const iso = /[Zz]|[+-]\d{2}:?\d{2}$/.test(s) ? s : s + 'Z'
  return new Date(iso)
}

export const fmtDateTime = (s) => {
  const d = asDate(s)
  return d ? d.toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'medium' }) : '–'
}

export const fmtTime = (s) => {
  const d = asDate(s)
  return d ? d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : ''
}

export function duration(r) {
  const a = asDate(r.startedAt), b = asDate(r.endedAt)
  if (!a || !b) return '–'
  const s = Math.max(0, Math.round((b - a) / 1000))
  return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, '0')}s`
}

// L'icona dice l'esito senza aprire: errore, concluso, o interrotto a metà — che è il caso per cui
// il diario esiste, e non ha né errore né risultato.
export function runIcon(r) {
  if (r.hasError) return 'mdi-alert-circle'
  if (r.hasResult) return 'mdi-check-circle'
  return 'mdi-progress-question'
}

export function runColor(r) {
  if (r.hasError) return 'error'
  if (r.hasResult) return r.verdict === 'error' ? 'warning' : 'success'
  return 'grey'
}
